import { render } from "./TdImageTextTile.vue?vue&type=template&id=bf864da8&scoped=true"
import script from "./TdImageTextTile.vue?vue&type=script&lang=js"
export * from "./TdImageTextTile.vue?vue&type=script&lang=js"

import "./TdImageTextTile.vue?vue&type=style&index=0&id=bf864da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf864da8"]])

export default __exports__